/**
 * 满幅页面判定（抽自 BasicLayout，避免主布局文件超规模上限）。
 *
 * 满幅页面本身按「铺满可用区域」设计：工作台是通话中的三栏操作台、流程设计器是整屏画布 ——
 * 它们不套内容宽度容器（`.bcc-content-wrap`），否则用户把「界面设置 → 内容宽度」调窄会把它们挤成窄条。
 *
 * 两个来源**分列**，别合并成一条前缀匹配：
 *   - `FULL_BLEED_ROUTES` 全等匹配：`/workbench`（坐席工作台，统一入口）；
 *     其它 `/workbench/*` 子路由（/workbench/tasks）是常规列表页，仍需内容宽度容器；
 *   - `FULL_BLEED_PREFIXES` 前缀匹配：设计器带 `:id` 参数，无法全等列出。
 */
export const FULL_BLEED_ROUTES = ['/workbench'];
export const FULL_BLEED_PREFIXES = ['/system/flows/designer'];

export const isFullBleed = (pathname: string) =>
  FULL_BLEED_ROUTES.includes(pathname) ||
  FULL_BLEED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
